<template>
  <div>
    <div class="modal-produto" v-if="aberto">
      <div class="modal-produto-content" tabindex="1">
        <div class="header-produto py-4 py-md-3 bg-white shadow-sm">
          <div class="container text-center">
            <div class="position-relative">
              <a href="javascript:" @click="closeModal()" class="btn btn-outline-light position-absolute" style="left: 0; top: -9px; border-radius: 50%" aria-label="Voltar">
                <i class="fa fa-chevron-left text-dark"></i>
              </a>
              <h1 class="h6 font-weight-bold m-auto" style="max-width: 60%; text-overflow: ellipsis; white-space: nowrap; overflow: hidden">
                Benefício
              </h1>
            </div>
          </div>
        </div>
        <div class="container-produto">
          <loading v-show="load" class="mt-4"/>
          <div v-if="!load">
            <div class="container my-3">
              <div v-if="menu === 1">
                <div class="card" aria-hidden="true" v-if="dados.url_imagem || dados.img_produto">
                  <img :src="dados.url_imagem || dados.img_produto" class="img-detalhes rounded-sm"/>
                </div>
                <div class="mt-3">
                  <h2 class="h5 mb-0">{{dados.titulo}}</h2>
                  <div>
                    <span class="badge badge-primary">{{ dados.pontos }} pontos</span>
                    <span class="badge badge-dark ml-1">Resgate {{ tipo_resgate === 1 ? 'no Delivery' : 'na Loja' }}</span>
                  </div>
                  <p class="mt-2 text-muted mb-0" v-if="dados.descricao" v-html="dados.descricao"></p>
                  <p class="text-muted mt-2" style="white-space: break-spaces" v-if="dados.descricao_produto" v-html="dados.descricao_produto"></p>
                </div>
                <hr>
                <div>
                  <h6>Como utilizar?</h6>
                  <p class="text-muted" v-if="dados.tipo_beneficio === '1'">
                    Na tela de finalizar o pedido, vá até a sessão cupons, procure o cupom deste benefício e clique em resgatar.
                  </p>
                  <p class="text-muted" v-else>
                    Clique em resgatar, {{ tipo_resgate === 1 ? 'acesse a sacola de produtos e finalize o seu pedido.' : 'apresente o código gerado para um de nossos atendentes no ato do seu pedido.'}}
                  </p>
                </div>
              </div>
              <div class="text-muted" v-if="menu === 2">
                <p class="mb-3">
                  Você está resgatando um benefício de <b>{{ dados.pontos }} pontos</b> no Programa de Vantagens.
                </p>
                <card-info :title="`Saldo atual: ${saldo}`" class="mb-4" icon="pontos">
                  <div class="small">Após este resgate: {{saldo - dados.pontos}} pontos</div>
                </card-info>
                <div>
                  <hr>
                  <label class="small">
                    <input type="checkbox" v-model="confirmar" class="mr-1" id="concordarFidelidade" v-if="tipo_resgate === 2">
                    Ao confirmar eu concordo em utilizar meus pontos para o resgate deste benefício{{ tipo_resgate === 2 ? ' e retirar em até 30 dias, caso contrário os pontos serão perdidos' : '' }}.
                  </label>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="border-top add-sacola">
          <button class="btn btn-block btn-primary btn-bottom" @click="resgatar()" v-if="saldo >= dados.pontos && dados.tipo_beneficio !== '1'">
            {{ menu === 1 ? 'Resgatar' : 'Confirmar Resgate' }}
          </button>
          <button class="btn btn-outline-primary btn-block btn-bottom" disabled v-else>
            <span v-if="saldo < dados.pontos">{{dados.pontos - saldo}} pontos para resgatar</span>
            <span v-else>Aplique na sacola</span>
          </button>
        </div>
      </div>
    </div>

    <produto ref="bProduto" :empresa-aberta="true" :beneficio="true" :is-componente="true" @retorno="finalizarResgate"/>
  </div>
</template>
<script>
  import Loading from "./Loading";
  import CardInfo from "./CardInfo";
  import Produto from "./Produto";
  export default {
    name: "BeneficioFidelidade",
    components: {Produto, CardInfo, Loading},
    props: ['saldo', 'tipo_resgate'],
    data() {
      return {
        aberto: false,
        dados: {},
        load: false,
        token: localStorage.getItem('token'),
        menu: 1,
        confirmar: false
      }
    },

    methods: {
      closeModal() {
        if (this.menu === 2) {
          this.menu = 1;

        } else {
          this.aberto = false;
          document.body.classList.remove("modal-open");
        }
      },

      scroll(top) {
        if (top) {
          top.scrollIntoView();
        }
      },

      resgatar() {
        if (this.tipo_resgate === 1 && this.dados.id_produto) {
          if (this.dados.produto_ativado !== '1') {
            this.$swal('No momento infelizmente este produto não esta disponível para resgate');
            return;
          }

          this.closeModal();
          this.$refs.bProduto.openProduto({ id: this.dados.id_produto, id_tabela: this.dados.id_tabela_preco });
        }

        if (this.menu === 1) {
          this.menu = 2;
          return;
        }

        if (!this.confirmar) {
          this.$swal('Clique na opção "Concordar" antes de confirmar o resgate').then(() => {
            this.$helpers.focusrElement('concordarFidelidade');
          });
          return;
        }

        this.load = true;
        this.$http.post(this.$store.state.base_url + this.token + '/resgatar-voucher', { id_beneficio: this.dados.id_beneficio })
          .then(response => {
            if (response.data && response.data.success) {
              document.body.classList.remove("modal-open");
              this.$router.push(this.url + '/perfil/meus-vouchers');
              this.$swal(response.data.msg || 'Voucher gerado com sucesso! Apresente o código a seguir para resgatar seu benefício.');

            } else {
              this.$emit('atualizar');
              this.$swal("Erro ao resgatar este benefífico. Tente novamente mais tarde")
            }

          }, res => {
            this.load = false;
            this.$swal(res.data && res.data.msg ? res.data.msg : 'Erro temporário');
          });
      },

      finalizarResgate(dados) {
        if (!dados) {
          this.openBeneficio(this.dados);
          return;
        }

        let valor = 0;
        const sacola = this.$store.state.sacola || { produtos: [] };

        dados.adicionais.forEach((d) => {
          valor += (d.valor * d.qtd) * dados.quantidade
        });

        sacola.produtos.unshift({
          ...dados, valor,
          pontos: this.dados.pontos,
          id_beneficio: this.dados.id_beneficio
        });

        this.$store.commit('setProdutosSacola', sacola);
        this.$swal('O produto foi adicionado à sua sacola!');
        this.$emit('fechar');
        this.closeModal();

        if (this.$helpers.isMobile()) {
          this.$router.push(this.url + '/sacola');
        }
      },

      openBeneficio(dados) {
        if (!dados || !dados.id_beneficio) {
          return;
        }

        this.load = true;
        this.dados = dados;
        this.aberto = true;
        this.confirmar = this.tipo_resgate === 1;
        this.menu = 1;
        document.body.classList.add("modal-open");

        setTimeout(() => {
          this.load = false;
        }, 600);
      }
    },

    created() {
      this.$parent.$on('openBeneficio', (dados) => {
        this.openBeneficio(dados);
      });

      this.$parent.$on('closeBeneficio', () => {
        this.closeModal();
      });
    },

    computed: {
      empresa() {
        return this.$store.state.empresa
      },

      url() {
        return this.$store.state.url
      }
    }
  }
</script>

<style scoped>
  .img-detalhes {
    width: 100%;
    height: 180px;
    object-fit: cover;
    object-position: center;
  }

  .modal-produto {
    display: block;
    position: fixed; /* Stay in place */
    z-index: 1040; /* Sit on top */
    left: 0;
    top: 0;
    width: 100%; /* Full width */
    height: 100%; /* Full height */
    background-color: rgb(0, 0, 0); /* Fallback color */
    background-color: rgba(0, 0, 0, 0.4); /* Black w/ opacity */
  }

  /* Modal Content/Box */
  .modal-produto-content {
    width: 100%;
    background-color: #fefefe;
  }

  .header-produto {
    position:fixed;
    right:0;
    top:0;
    left:0;
    z-index:1030;
  }

  .add-sacola {
    position:fixed;
    right:0;
    bottom:0;
    left:0;
    z-index:1030;
    padding: 0.5rem 15px;
    background-color: #ffffff;
  }

  .ios_platform .add-sacola {
    padding-bottom: 32px;
  }

  .container-produto {
    padding: 68px 0 156px;
    height: 100vh;
    overflow: auto;
  }

  @media (min-width: 768px) {
    .modal-produto-content {
      margin: 15px auto;
      width: 450px;
      position: relative;
      border-radius: 6px;
      overflow: hidden;
    }

    .header-produto {
      position: static;
    }

    .add-sacola {
      position: static;
      padding: 12px;
    }

    .container-produto {
      overflow: auto;
      height: calc(90vh - 130px);
      padding: 0 0 12px 0;
    }
  }
</style>
